import axios from "axios";

const api = axios.create({
   baseURL:"https://api.propex20dev.com"
   // https://api.propex20dev.com
})

export default api